import type {AgentLoopCheckpoint,StoryMessageDocument,WorldDocument,WorldTransaction,DiceResult,JsonObject} from '@private-fiction/story-core';
export interface PendingPlayerRoll {runId:string;callId:string;actorKey:string;request:JsonObject;result?:DiceResult;requestedAt?:string;resolvedAt?:string}
export interface GmTurnRecovery {
  runId:string;revision:number;baseMessages:StoryMessageDocument[];requestPurpose:'story'|'continue';temporaryPrompt:string;previousVariants:string[];
  loop:AgentLoopCheckpoint;turnBaseDocuments:WorldDocument[];stagedDocuments:WorldDocument[];changedIds:string[];
  gmModel:string;mode:string;workMs:number;waitMs:number;
  decisionRequests?:number;narrationRequests?:number;contextMs?:number;decisionMs?:number;
  decision?:(string) | undefined;decisionReady?:boolean;committedDocuments?:WorldDocument[];
  compactOutcome?:import('@private-fiction/story-core').CompactTurnOutcome;
  partialDocuments?:boolean;
  resolvedPlayerRoll?:(PendingPlayerRoll) | undefined;
  narrationText?:(string) | undefined;
  turnSceneHeaders?:(Record<string,import('./turnScene').TurnScene>) | undefined;
  usage?:{reports:number;inputTokens:number;outputTokens:number;cachedReadTokens:number};
}
export function restoreTurnDocuments(current:readonly WorldDocument[],snapshot:readonly WorldDocument[],partial=false):WorldDocument[] {
  if(!partial) return structuredClone([...snapshot]);
  const replacements=new Map(snapshot.map(doc=>[doc.id,doc]));
  return structuredClone([...current.filter(doc=>!replacements.has(doc.id)),...snapshot]);
}
export function recoveredTurnTransaction(sessionId:string,recovery:GmTurnRecovery):WorldTransaction {
  return {id:recovery.runId,storyId:sessionId,actor:'narrator',createdAt:new Date().toISOString(),mutations:recovery.changedIds.map(id=>{
    const before=recovery.turnBaseDocuments.find(doc=>doc.id===id),after=recovery.committedDocuments?.find(doc=>doc.id===id);
    if(!after || after.storyId!==sessionId) throw new Error('Missing committed turn file');
    return {operation:before?'replace':'create',documentId:id,expectedRevision:before?.revision ?? 0,document:after,reason:'Canonical pre-narration turn commit',sourceMessageIds:recovery.baseMessages.slice(-2).map(message=>String(message.id))};
  })};
}
